import React from 'react';

const ProjectOneDetails = () => {
    return (
        <div>
            
        </div>
    );
};

export default ProjectOneDetails;